<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客服管理</el-breadcrumb-item>
      <el-breadcrumb-item>预约列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: flex-start;align-items: flex-end">
      <el-button size="mini" plain @click="showReserveDialog">添加预约</el-button>
      <el-date-picker
        v-model="reserveRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select v-model="reserveRequest.shopId" size="mini" placeholder="请选择门店" clearable
                 v-if="orgLevel < 3"
                 @change="selectShop">
        <el-option
          v-for="item in shops"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="reserveRequest.tgType" size="mini" placeholder="请选择团购类型" clearable
                 @change="selectTgType">
        <el-option
          v-for="item in tgList"
          :key="item.id"
          :label="item.serviceTypeName"
          :value="item.serviceTypeName">
        </el-option>
      </el-select>
      <el-select v-model="reserveRequest.state" size="mini" placeholder="请选择状态类型" clearable
                 @change="selectState">
        <el-option
          v-for="item in states"
          :key="item.state"
          :label="item.label"
          :value="item.state">
        </el-option>
      </el-select>
      <el-button size="mini" plain @click="loadReserve">查询</el-button>
    </div>

    <el-table height="510px" :data="reserveList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333'}" :row-style="{height: '0'}">
      <el-table-column
        label="操作"
        fixed="fixed"
        align="center"
        width="100">
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-around">
            <el-link icon="iconfont icon-dingdanshenpi" type="primary" title="新建消费单" :disabled="scope.row.state == 4"
                     @click="toOrder(scope.row)"></el-link>
            <el-link icon="el-icon-edit" type="primary" title="修改" :disabled="scope.row.state == 4"
                     @click="showEditReserveDialog(scope.row)"></el-link>
            <el-link icon="iconfont icon-zuofei" type="danger" title="作废" :disabled="scope.row.state == 4"
                     @click="cancelReserve(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="致电时间"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="name"
        label="顾客姓名"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="顾客电话"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="state"
        label="状态"
        align="center"
        :formatter="stateFormatter"
        width="100">
      </el-table-column>
      <el-table-column
        prop="reserveDate"
        label="预约日期"
        align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="reserveTime"
        label="到店时间"
        align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="tgType"
        label="团购类型"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="hyCode"
        label="待核验码"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="shopName"
        label="预约门店"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="money"
        label="消费金额"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="createName"
        label="添加人"
        align="center"
        width="100">
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="reserveSizeChange"
        @current-change="reserveCurrentChange"
        :current-page="reserveCurrentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="reservePageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="reservePageTotal">
      </el-pagination>
    </div>

    <el-dialog
      title="添加预约"
      :visible.sync="addReserveVisible"
      width="70%"
      @close="closeReserveDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex;justify-content: center;align-items:center;width: 100%">
          <el-input v-model="reserveRequest.queryText" placeholder="请输入会员手机号或者会员姓名，搜索会员" size="mini" style="width: 50%;"></el-input>
          <el-button size="mini" plain @click="queryCustomer">搜索一下</el-button>
        </div>

        <div style="display: flex;justify-content: space-around; margin-top: 10px">
          <div style="width: 50%">
            <span style="width: 30%">顾客姓名:</span>
            <el-input v-model="reserve.name" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">顾客电话:</span>
            <el-input v-model="reserve.phone"  size="mini" style="width: 70%;" />
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">预约门店:</span>
            <el-select v-model="reserve.shopId" size="mini" placeholder="请选择门店" clearable filterable
                       @change="selectAddShop">
              <el-option
                v-for="item in shops"
                :key="item.id"
                :label="item.orgName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">所属区域:</span>
            <el-input v-model="reserve.areaName" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">预约日期:</span>
            <el-date-picker
              v-model="reserve.reserveDate"
              type="date"
              size="mini"
              :disabled="reserve.shopId == ''"
              placeholder="选择日期"
              @change="selectAddReserveData"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">到店时间:</span>
            <el-select v-model="selectedTime" size="mini"
                       placeholder="请选择时段" clearable filterable
                       @change="selectReserveTimeMethod">
              <el-option
                v-for="item in reserveTimes"
                :key="item.value"
                :label="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">团购类型:</span>
            <el-select v-model="selectedTgType" size="mini" @change="selectAddTgType"
                       placeholder="请选择类型类型"  style="width: 70%">
              <el-option
                v-for="item in tgList"
                :key="item.id"
                :label="item.serviceTypeName"
                :value="item.serviceTypeName">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">待核验码:</span>
            <el-input v-model="reserve.hyCode" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeReserveDialog">取 消</el-button>
        <el-button size="mini" @click="createReserve">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择会员 -->
    <el-dialog
      title="会员列表"
      width="60%"
      :visible.sync="selectCustomerDialogVisible"
      :before-close="closeSelectCustomerDialog"
      show-close
      modal
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="selectCustomerList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="400px">
        <el-table-column
          align="center"
          label="操作"
          width="110">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="selectedCustomer"
                      @change.native="selectCustomer(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="customerName"
          label="会员名称" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="registerOrgName"
          label="所属门店" >
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="selectCustomerSizeChange"
          @current-change="selectCustomerCurrentChange"
          :current-page="selectCustomerCurrentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="selectCustomerPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="selectCustomerPageTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑预约"
      :visible.sync="editReserveVisible"
      width="70%"
      @close="closeEditReserveDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex;justify-content: center;align-items:center;width: 100%">
          <el-input v-model="reserveRequest.queryText" placeholder="请输入会员手机号或者会员姓名，搜索会员" size="mini" style="width: 50%;"></el-input>
          <el-button size="mini" plain @click="queryCustomer">搜索一下</el-button>
        </div>

        <div style="display: flex;justify-content: space-around; margin-top: 10px">
          <div style="width: 50%">
            <span style="width: 30%">顾客姓名:</span>
            <el-input v-model="editReserve.name" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">顾客电话:</span>
            <el-input v-model="editReserve.phone"  size="mini" style="width: 70%;" />
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">预约门店:</span>
            <el-select v-model="editReserve.shopId" size="mini" placeholder="请选择门店" clearable filterable
                       @change="selectAddShop">
              <el-option
                v-for="item in shops"
                :key="item.id"
                :label="item.orgName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">所属区域:</span>
            <el-input v-model="editReserve.areaName" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">预约日期:</span>
            <el-date-picker
              v-model="editReserve.reserveDate"
              type="date"
              size="mini"
              :disabled="reserve.shopId == ''"
              placeholder="选择日期"
              @change="selectAddReserveData"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">到店时间:</span>
            <el-select v-model="editReserve.reserveTime" size="mini"
                       placeholder="请选择时段" clearable filterable
                       @change="selectReserveTimeMethod">
              <el-option
                v-for="item in reserveTimes"
                :key="item.value"
                :label="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;margin-top: 15px">
          <div style="width: 50%">
            <span style="width: 30%">团购类型:</span>
            <el-select v-model="editReserve.tgType" size="mini" @change="selectAddTgType"
                       placeholder="请选择类型类型"  style="width: 70%">
              <el-option
                v-for="item in tgList"
                :key="item.id"
                :label="item.serviceTypeName"
                :value="item.serviceTypeName">
              </el-option>
            </el-select>
          </div>
          <div style="width: 50%">
            <span style="width: 30%">待核验码:</span>
            <el-input v-model="editReserve.hyCode" placeholder="请输入内容" size="mini" style="width: 70%;"/>
          </div>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeEditReserveDialog">取 消</el-button>
        <el-button size="mini" @click="editReserveMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      shopId:'',
      userId:'',
      orgLevel:0,
      orgName:'',
      reserveList:[],
      shops:[],
      tgList:[],
      selectedTime:'',
      selectedTgType:'',
      states:[
        {state:1, label:'预约中'},
        {state:2, label:'已到店'},
        {state:3, label:'未到店'},
        {state:4, label:'已作废'}
      ],
      stateText:[
        {state:1,name:'预约中'},
        {state:2,name:'已到店'},
        {state:3,name:'未到店'},
        {state:4,name:'已作废'},
      ],
      reserveRequest:{
        selectDate:'',
        orgId: '',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        areaId:0,
        shopId:'',
        queryText:'',
        name:'',
        phone:'',
        tgType:''
      },
      reserve:{
        reserveDate:'',
        name:'',
        customerId:'',
        phone:'',
        tgType:'',
        hyCode:'',
        shopId:'',
        shopName:'',
        areaName:'',
        areaId:'',
        creator:0,
        reserveDateStr:''
      },
      reserveCurrentPage: 1,
      reservePageSize:20,
      reservePageTotal:0,
      addReserveVisible:false,
      selectCustomerDialogVisible:false,
      selectCustomerList:[],
      selectedCustomer:'',

      selectCustomerCurrentPage: 1,
      selectCustomerPageSize:20,
      selectCustomerPageTotal:0,

      editReserveVisible:false,
      editReserve:{
        name:'',
        customerId:'',
        phone:'',
      },
      selectEditDate:'',
      reserveTimes:[],
      initTimes: [{
        value: '9:00-10:00',
        text: "9:00-10:00"
      },
        {
          value: '10:00-11:00',
          text: "10:00-11:00"
        },
        {
          value: '11:00-12:00',
          text: "11:00-12:00"
        },
        {
          value: '12:00-13:00',
          text: "12:00-13:00"
        },
        {
          value: '13:00-14:00',
          text: "13:00-14:00"
        },
        {
          value: '14:00-15:00',
          text: "14:00-15:00"
        },
        {
          value: '15:00-16:00',
          text: "15:00-16:00"
        },
        {
          value: '16:00-17:00',
          text: "16:00-17:00"
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          let now = new Date().setHours(0,0,0,0)
          return time.getTime() < new Date(now).getTime()
        }
      },
      selectShopId:'',
    }
  },
  methods: {
    showReserveDialog(){
      this.clear();
      this.loadTgList();
      this.loadShopList();
      this.addReserveVisible = true;
    },
    closeReserveDialog(){
      this.addReserveVisible = false;
    },
    selectKpiData(date){
      if (date === null || date === ''){
        this.reserveRequest.startDate = '';
        this.reserveRequest.endDate = '';
      } else {
        this.reserveRequest.startDate = date[0];
        this.reserveRequest.endDate = date[1];
      }
    },
    async selectAddReserveData(data){
      if(data !== this.getCurrentDate()){
        this.reserveTimes = this.initTimes
      } else {
        this.initReserveTime();
      }
      this.selectedTime = '';
    },
    getCurrentDate(){
      let today = new Date();
      let year = today.getFullYear();//获取年份
      let month = today.getMonth() + 1;//获取月份
      let day = today.getDate();//获取日期
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + "-" + month + "-" + day;
    },
    selectAddTgType(data){
      this.reserve.tgType = data;
    },
    selectShop(data){
      this.reserveRequest.shopId = data;
    },
    selectAddShop(data){
      this.loadArea(data);
    },
    selectTgType(data){
      this.reserveRequest.tgType = data;
    },
    selectState(data){
      this.reserveRequest.state = data;
    },
    loadReserve(){
      this.reserveRequest.pageNum = this.reserveCurrentPage;
      this.reserveRequest.pageSize = this.reservePageSize;
      this.loadReserveCount();
      this.loadReserveList();
    },
    async loadReserveCount(){
      const {data:res} = await this.$http.post(`/reserve/count`,this.reserveRequest)
      this.reservePageTotal = res.totalPage;
    },
    async loadReserveList(){
      const {data:res} = await this.$http.post(`/reserve/list`,this.reserveRequest)
      this.reserveList = res.data;
    },
    addOrderDialog(){

    },
    async cancelReserve(row){
      row.modifier = this.userId;
      const {data:res} = await this.$http.post(`/cancel/reserve`, row);
      if (res.code == 200){
        this.$message.success("操作成功！");
      }
      this.loadReserve();
    },
    reserveSizeChange(val) {
      this.reservePageSize = val;
      this.loadContentList();
    },
    reserveCurrentChange(val) {
      this.reserveCurrentPage = val;
      this.loadContentList();
    },
    queryCustomer(){
      if(this.reserveRequest.queryText == ''){
        this.$message.warning("请输入要查询的会员")
        return;
      }
      this.selectedCustomer = '';
      this.selectCustomerList = [];
      this.reserveRequest.pageNum = this.selectCustomerCurrentPage;
      this.reserveRequest.pageSize = this.selectCustomerPageSize;
      this.loadCustomerCount();
      this.loadCustomerList();
      this.showSelectCustomerDialog();
    },
    async loadCustomerCount(){
      const {data:res} = await this.$http.post(`/load/reserve/customer/count`,this.reserveRequest)
      this.selectCustomerPageTotal = res.totalPage;
    },
    async loadCustomerList(){
      const {data:res} = await this.$http.post(`/load/reserve/customer/list`,this.reserveRequest)
      this.selectCustomerList = res.data;
    },
    async loadTgList(){
      const {data:res} = await this.$http.get(`/load/tg/list`)
      this.tgList = res.data;
    },
    async loadShopList(){
      const {data:res} = await this.$http.get(`/load/all/shops`)
      this.shops = res.data;
    },
    async loadArea(shop){
      const {data:res} = await this.$http.get(`/load/area/${shop}`)
      this.reserve.areaName = res.data.orgName;
      this.reserve.areaId = res.data.id;
    },
    showSelectCustomerDialog(){
      this.selectCustomerDialogVisible = true;
    },
    closeSelectCustomerDialog(){
      this.selectCustomerDialogVisible = false;
    },
    async selectCustomer(data){
      this.reserve.name = data.customerName;
      this.reserve.phone = data.phone;
      this.reserve.customerId = data.id;

      this.editReserve.name = data.customerName;
      this.editReserve.phone = data.phone;
      this.editReserve.customerId = data.id;
      this.closeSelectCustomerDialog();
    },
    async createReserve(){
      this.reserve.creator = this.userId;
      const {data:res} = await this.$http.post(`/new/reserve`,this.reserve);
      if (res.code == 200){
        this.$message.success("操作成功！");
      }
      this.closeReserveDialog();
    },
    selectCustomerSizeChange(val) {
      this.selectCustomerPageSize = val;
      this.getCustomers();
    },
    selectCustomerCurrentChange(val) {
      this.selectCustomerCurrentPage = val;
      this.getCustomers();
    },
    clear(){
      this.reserveRequest.queryText='';
      this.reserve.name = '';
      this.reserve.customerId = '';
      this.reserve.phone = '';
      this.reserve.tgType = '';
      this.reserve.hyCode = '';
      this.reserve.shopId = '';
      this.reserve.shopName = '';
      this.reserve.areaName = '';
      this.reserve.areaId = '';
      this.reserve.reserveDate='';
      this.selectedTime = '';
      this.reserve.contentType=''
      this.selectedTgType= '';
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    showEditReserveDialog(row){
      this.editReserve = row;
      let selectDate = [];
      selectDate[0] = row.startDate;
      selectDate[1] = row.endDate;
      this.selectEditDate = selectDate;
      this.editReserveVisible = true;
    },
    closeEditReserveDialog(){
      this.editReserveVisible = false;
    },
    async editReserveMethod(){
      this.editReserve.modifier = this.userId;
      const {data:res} = await this.$http.post(`/edit/reserve`,this.editReserve);
      if (res.code == 200){
        this.$message.success("操作成功！");
      }
      this.closeEditReserveDialog();
      this.loadReserve();
    },
    async selectEditReserveDate(data){
      if (data === null || data === ''){
        this.editReserve.startDate = '';
        this.editReserve.endDate = '';
      } else {
        this.editReserve.startDate = data[0];
        this.editReserve.endDate = data[1];
        const {data:res} = await this.$http.post(`/check/reserve/time`,this.editReserve)
        if (res.totalPage >= 2){
          this.$message.warning("此时间段已经有2位顾客预约，请重新选择时间段");
          this.editReserve.startDate = '';
          this.editReserve.endDate = '';
          this.editReserve.selectDate = '';
        }
      }
    },
    toOrder(row){
      this.$router.push({path:'/orders', query:{reserveId:row.id, customerId:row.customerId, reserveShopId: row.shopId}});
    },
    async selectReserveTimeMethod(e) {
      this.reserve.reserveTime = e;
      if (this.reserve.reserveDate !== '' && e !== ''){
        this.reserve.reserveDateStr = this.reserve.reserveDate;
        const {data:res} = await this.$http.post(`/check/reserve/time`,this.reserve)
        if (res.totalPage >= 2){
          this.$message.warning("此时间段已经有2位顾客预约，请重新选择时间段");
          this.reserve.reserveTime = '';
          this.selectedTime = '';
        }
      }
    },
    initReserveTime(){
      this.reserveTimes = [];
      let currentHour = new Date().getHours();
      this.initTimes.map((item)=>{
        let tempTime = item.value.split('-')[0];
        let hour = tempTime.split(':')[0];
        if(hour > currentHour){
          this.reserveTimes.push(item)
        }
      })
    }
  },
  created() {
    this.shopId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadTgList();
    if (this.orgLevel == 1){
      this.loadReserve();
      this.loadShopList();
    }
    if (this.orgLevel == 2){
      this.reserveRequest.areaId = this.shopId;
      this.loadShopList();
      this.loadReserve();
    }
    if (this.orgLevel == 3){
      this.reserveRequest.shopId = this.shopId;
      this.loadReserve();
    }
    this.initReserveTime();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Reserves.vue